export function getSubmenuLinkMatchLength(currentPath, parentRoute, subitem) {
  const linkPath = `${parentRoute}${subitem.route}`
  const paths = [linkPath, ...(subitem.activeRoutes || [])]

  return paths.reduce((maxLength, path) => {
    if (currentPath === path || currentPath?.startsWith(`${path}/`)) {
      return Math.max(maxLength, path.length)
    }

    return maxLength
  }, 0)
}

export function isSubmenuLinkActive(
  currentPath,
  parentRoute,
  subitem,
  siblings = []
) {
  const matchLength = getSubmenuLinkMatchLength(
    currentPath,
    parentRoute,
    subitem
  )
  if (matchLength === 0) return false

  const maxSiblingMatchLength = siblings
    .filter((sibling) => sibling.enabled)
    .reduce(
      (maxLength, sibling) =>
        Math.max(
          maxLength,
          getSubmenuLinkMatchLength(currentPath, parentRoute, sibling)
        ),
      0
    )

  return matchLength === maxSiblingMatchLength
}
